import React from 'react';

const IconFork = ({ size = 24, color = 'currentColor' }) => (
  <svg
    viewBox="0 0 24 24"
    width={size} // optional size
    height={size} // optional size
    fill="none"
    stroke={color} // optional stroke color
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-git-branch">
    <title>Git Fork</title>
    <line x1="6" y1="3" x2="6" y2="15" />
    <circle cx="18" cy="6" r="3" />
    <circle cx="6" cy="18" r="3" />
    <path d="M18 9a9 9 0 0 1-9 9" />
  </svg>
);

export default IconFork;
